import { BadgeCheck, Leaf, ShieldCheck, Snowflake, type LucideIcon } from "lucide-react";

export interface Certification {
  icon: LucideIcon;
  title: string;
  body: string;
}

export const CERTIFICATIONS: Certification[] = [
  {
    icon: BadgeCheck,
    title: "FSSAI Licensed",
    body: "Every ZenFresh facility operates under a valid Food Safety and Standards Authority of India license, renewed and audited annually.",
  },
  {
    icon: Snowflake,
    title: "Cold-Chain Certified",
    body: "Temperature-controlled from dock to doorstep, with logged monitoring at every handoff — packing, transit, and last-mile delivery.",
  },
  {
    icon: Leaf,
    title: "Sustainable Sourcing",
    body: "Partner fisheries operate within certified sustainable-catch limits; no partner fishery is added without a sourcing review.",
  },
  {
    icon: ShieldCheck,
    title: "Hygiene Audited",
    body: "Quarterly third-party hygiene audits across processing and packing facilities, with corrective-action tracking on any finding.",
  },
];
